import cn from 'clsx';

import { useSurveyProgressBar } from '@/components/survey/common/hooks/use-progress-bar';
import s from '@/components/survey/common/ui/styles/ProgressBar.module.scss';

interface Props {
  step: 1 | 2 | 3 | 4 | 5;
}

export const ProgressBar = ({ step }: Props) => {
  const { companyName, hasEmployees } = useSurveyProgressBar();

  // loading fallback
  if (!companyName) {
    return (
      <div className={s.wrapper}>
        <p className={'h-[22px]'} />
        <div className={s.bar}>
          <span className={s.progress} />
        </div>
      </div>
    );
  }

  return (
    <div className={s.wrapper}>
      <p className={s.title}>{companyName}에 대한 질문</p>
      <div className={s.bar}>
        <span className={cn(s.progress, s[`case_${hasEmployees ? 1 : 2}_${step > 1 && !hasEmployees ? step - 1 : step}`])} />
      </div>
    </div>
  );
};
